import { Collection } from 'modules/core/lib/mobx-rest'

import type Employee from 'modules/employees/store/models/Employee'
import FamilySituation from 'modules/employees/store/models/FamilySituation'

class FamilySituations extends Collection<FamilySituation> {
  get cacheKey(): string {
    return 'familySituations'
  }

  get indexes() {
    return ['employee_id']
  }

  model() {
    return FamilySituation
  }

  findByEmployee(employee: Employee) {
    const familySituation = this.find({
      employee_id: employee.id,
    })

    if (familySituation) return familySituation

    return FamilySituation.getNull(+employee.id)
  }

  findByEmployeeId(employeeId: number) {
    const familySituation = this.find({
      employee_id: employeeId,
    })

    if (familySituation) return familySituation

    return FamilySituation.getNull(+employeeId)
  }
}

export { FamilySituations }
